import React from 'react';
import { connect } from 'react-redux';
import { Button, IconButton } from 'react-toolbox/lib/button';
import { create } from '~/actions/containers';
import LocationPicker from '~/components/LocationPicker';
import OrderPicker from '~/components/OrderPicker';
import NumericInput from 'react-numeric-input';
import Dropdown from 'react-toolbox/lib/dropdown';
import DatePicker from '~/components/DatePicker';
import styleDialog from '~/style/dialog.scss';
import styleLocal from './style.scss';

const types = [
  { value: 'box', label: 'Box' },
  { value: 'pallet', label: 'Pallet' },
  { value: 'letter', label: 'Letter' },
  { value: 'container', label: 'Shipping Container' },
];

class Dialog extends React.Component {
  static contextTypes = {
    dialogClose: React.PropTypes.func.isRequired,
    apiClient: React.PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {};
  }

  submit() {
    return create(this.props.dispatch, this.context.apiClient, this.state)
      .then(() => this.context.dialogClose(this.props.dialogId))
      .then(() => this.props.data.onCreate && this.props.data.onCreate());
  }

  render() {
    return (
      <div className={[styleDialog.background, styleDialog[this.props.transition]].join(' ')} onClick={() => this.context.dialogClose(this.props.dialogId)}>
        <div className={styleDialog.container} onClick={e => e.stopPropagation()}>
          <IconButton className={styleDialog.closeButton} icon="close" onClick={() => this.context.dialogClose(this.props.dialogId)} />
          <div className={styleDialog.content}>
            <form onSubmit={e => { e.preventDefault(); this.submit(); }}>
              <Dropdown
                auto
                label="Container type"
                onChange={type => this.setState({ type })}
                source={types}
                value={this.state.type}
              />
              <div className={styleLocal.dimensions}>
                <div>Dimensions (meter)</div>
                <NumericInput
                  step={0.1}
                  min={0.01}
                  precision={2}
                  label="width"
                  snap
                  value={(this.state.dimensions || { width: 0 }).width}
                  onChange={width => this.setState(
                    { dimensions: { ...this.state.dimensions, width } })}
                  style={{ width: '80px' }}
                />
                &nbsp;x&nbsp;
                <NumericInput
                  step={0.1}
                  min={0.01}
                  precision={2}
                  label="height"
                  snap
                  value={(this.state.dimensions || { height: 0 }).height}
                  onChange={height => this.setState(
                    { dimensions: { ...this.state.dimensions, height } })}
                />
                &nbsp;x&nbsp;
                <NumericInput
                  step={0.1}
                  min={0.01}
                  precision={2}
                  label="depth"
                  snap
                  value={(this.state.dimensions || { depth: 0 }).depth}
                  onChange={depth => this.setState(
                    { dimensions: { ...this.state.dimensions, depth } })}
                />
              </div>
              <div className={styleLocal.dimensions}>
                <div>Weight (kilo)</div>
                <NumericInput
                  step={0.1}
                  min={0.001}
                  precision={3}
                  label="weight"
                  snap
                  value={this.state.weight || 0}
                  onChange={weight => this.setState({ weight })}
                  style={{ width: '80px' }}
                />
              </div>
              <div style={{ paddingBottom: '10px' }}>
                Location
                <LocationPicker
                  style={{ marginLeft: '20px' }}
                  value={this.state.locationId || null}
                  onChange={locationId => this.setState({ locationId })}
                />
              </div>
              <div style={{ paddingBottom: '10px' }}>
                Order
                <OrderPicker
                  style={{ marginLeft: '20px' }}
                  value={this.state.orderId || null}
                  onChange={orderId => this.setState({ orderId })}
                />
              </div>
              <div>
                <DatePicker
                  label="ETA"
                  locale="en"
                  sundayFirstDayOfWeek
                  value={this.state.eta ? new Date(this.state.eta) : null}
                  onChange={v => this.setState({ eta: v })}
                  onDismiss={() => this.setState({ eta: null })}
                />
              </div>
              <Button label="Create" type="submit" primary raised />
            </form>
          </div>
        </div>
      </div>
    );
  }
}

export default connect()(Dialog);



// WEBPACK FOOTER //
// ./app/dialogs/ContainerNew/index.js